<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e1984"><b>CONTENTS </b></p>
<p class="ser"><img alt="4" src="images/4.jpg" style="max-width:100%"/></p><p class="cctc" id="d8e3361"><a href="#/Haye_ISBN9781605501390_epub_c4_r1#d7e2816" id="d14e136">PART I <br/><i>Words You Absolutely Should Know</i></a></p>
<p class="cctc" id="d8e251051"><span href="#/Haye_ISBN9781605501390_epub_c6_r1#d7e26187150" id="d14e142" title="Link target outside of Sample">PART II <br/><i>Words Most People Don’t Know</i></span></p>
<p class="cctc" id="d8e384381"><span href="#/Haye_ISBN9781605501390_epub_c7_r1#d7e40044228" id="d14e148" title="Link target outside of Sample">PART III <br/><i>Words You Should Know but Probably Don’t</i></span></p>
<p class="cctc" id="d8e515821"><span href="#/Haye_ISBN9781605501390_epub_c8_r1#d7e53720306" id="d14e154" title="Link target outside of Sample">PART IV <br/><i>Foreign Idioms You Should Know</i></span></p>
<p class="cctc" id="d8e531881"><span href="#/Haye_ISBN9781605501390_epub_c9_r1#d7e55374318" id="d14e160" title="Link target outside of Sample">PART V <br/><i>People and Place Words You Should Know</i></span></p>
<p class="cctc" id="d8e548711"><span href="#/Haye_ISBN9781605501390_epub_c10_r1#d7e57075330" id="d14e166" title="Link target outside of Sample">PART VI <br/><i>Words You Should Know to Sound Overeducated</i></span></p>
<p class="cctc" id="d8e681791"><span href="#/Haye_ISBN9781605501390_epub_c11_r1#d7e71026408" id="d14e172" title="Link target outside of Sample">PART VII <br/><i>Words You Probably Shouldn’t Know</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Haye_ISBN9781605501390_epub_c3_r1.vue?1c4cc027